{
  "search": {
    "entry": "Search",
    "title": "Quick find",
    "placeholder": "Search {{scope}}",
    "placeholderAny": "Search",
    "scope": {
      "catalogue_items": "catalogue items",
      "requests": "purchase requests",
      "purchase_orders": "purchase orders",
      "rfqs": "enquiries",
      "suppliers": "suppliers",
      "orders": "your orders",
      "rfq_invitations": "your enquiries",
      "organisations": "organisations",
      "invoices": "your invoices"
    },
    "group": {
      "catalogue_items": "Catalogue items",
      "requests": "Purchase requests",
      "purchase_orders": "Purchase orders",
      "rfqs": "Enquiries",
      "suppliers": "Suppliers",
      "orders": "Your orders",
      "rfq_invitations": "Your enquiries",
      "organisations": "Organisations",
      "navigation": "Go to",
      "help": "Help",
      "invoices": "Your invoices",
      "best": "Best match",
      "recent": "Recent searches",
      "commands": "Start"
    },
    "help": {
      "keywords": "help guide guides guided tour tours",
      "all": "All help and tours",
      "allHint": "Opens Help & tours."
    },
    "seeAll": "See all in {{list}}",
    "results": "Results",
    "initial": "Type at least two letters, or a number.",
    "initialScope": "Searches {{scope}} you can already open. Nothing is changed.",
    "searching": "Searching…",
    "noResults": "No matches for “{{term}}”",
    "noResultsHint": "Check the spelling, or try a number or code.",
    "failed": "Search failed",
    "failedHint": "This is not an empty result: the search did not run. Nothing was changed.",
    "partial": "Not searched just now: {{groups}}",
    "partialHint": "The other results below are complete.",
    "noneIn": "No matches in {{groups}}.",
    "clearInput": "Clear the search text",
    "close": "Close search",
    "keys": {
      "label": "Keyboard",
      "move": "move",
      "open": "open",
      "close": "close"
    },
    "announce": "Results shown: {{count}}",
    "status": {
      "requests": {
        "draft": "Draft",
        "pending_approval": "Pending approval",
        "approved": "Approved",
        "returned": "Returned for amendment",
        "rejected": "Rejected",
        "cancelled": "Cancelled",
        "procurement_review": "With procurement",
        "sourcing_required": "Sourcing required",
        "procurement_processing": "Procurement processing",
        "po_created": "PO created"
      },
      "purchase_orders": {
        "draft": "Draft",
        "issued": "Issued",
        "sent": "Sent to supplier",
        "active": "Active",
        "completed": "Completed",
        "cancelled": "Cancelled",
        "pending": "Awaiting supplier",
        "acknowledged": "Acknowledged",
        "query": "Query raised",
        "partially_available": "Partially available",
        "declined": "Declined"
      },
      "orders": {
        "issued": "Issued",
        "sent": "Sent to supplier",
        "active": "Active",
        "completed": "Completed",
        "cancelled": "Cancelled",
        "pending": "Awaiting supplier",
        "acknowledged": "Acknowledged",
        "query": "Query raised",
        "partially_available": "Partially available",
        "declined": "Declined"
      },
      "rfqs": {
        "draft": "Draft",
        "open": "Open",
        "awarded": "Awarded",
        "no_award": "No award",
        "cancelled": "Cancelled"
      },
      "rfq_invitations": {
        "invited": "Invited",
        "responded": "Responded",
        "late": "Late",
        "incomplete": "Incomplete",
        "withdrawn": "Withdrawn",
        "non_responsive": "No response"
      },
      "suppliers": {
        "draft": "Draft",
        "active": "Active",
        "suspended": "Suspended",
        "archived": "Archived"
      },
      "organisations": {
        "provisioning": "Being set up",
        "active": "Active",
        "suspended": "Suspended",
        "closed": "Closed"
      }
    },
    "seeAllFor": "Search all {{list}} for “{{term}}”",
    "noneInByName": "No number or name matches in {{groups}}.",
    "tooMany": "Too many searches in a short time",
    "tooManyHint": "Wait a moment, then try again. Nothing was changed.",
    "announceMore": "More in {{groups}}.",
    "moreAvailable": "more available",
    "shown_zero": "{{count}} shown",
    "shown_one": "1 shown",
    "shown_two": "{{count}} shown",
    "shown_few": "{{count}} shown",
    "shown_many": "{{count}} shown",
    "shown_other": "{{count}} shown",
    "commandHint": "Opens the form. Nothing is created until you save there.",
    "recent": {
      "clear": "Clear recent searches",
      "cleared": "Recent searches cleared."
    },
    "coach": {
      "kind": "Guided workflow",
      "start": "Start",
      "continue": "Continue at step {{step}} of {{total}}",
      "running": "Running now: show it",
      "completed": "Completed: start again"
    },
    "shell": {
      "waiting_zero": "{{count}} waiting for you",
      "waiting_one": "1 waiting for you",
      "waiting_two": "{{count}} waiting for you",
      "waiting_few": "{{count}} waiting for you",
      "waiting_many": "{{count}} waiting for you",
      "waiting_other": "{{count}} waiting for you"
    }
  },
  "shared": {
    "state": {
      "noAccessTitle": "Not available with your access",
      "noAccessBody": "Your role does not include this. If your work needs it, ask your administrator.",
      "notFoundTitle": "This record could not be found",
      "notFoundBody": "The link may be out of date, or the record may not be one you can open.",
      "loadFailedTitle": "This page could not be loaded",
      "goTo": "Go to {{place}}",
      "filterTitle": "A filter in this link can't be applied",
      "filterBody": "It names something that no longer exists, or is outside what you can see. Choose Clear all to see the whole list."
    },
    "list": {
      "resultCount": "Results: {{count}}"
    }
  }
}
